import { render, staticRenderFns } from "./AlertCategory.global.vue?vue&type=template&id=399534c8&lang=pug&"
import script from "./AlertCategory.global.vue?vue&type=script&lang=ts&"
export * from "./AlertCategory.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports